import { render, staticRenderFns } from "./RoomStatusColor.vue?vue&type=template&id=0cfd1654&"
import script from "./RoomStatusColor.vue?vue&type=script&lang=js&"
export * from "./RoomStatusColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports